module.exports = __webpack_public_path__ + "img/xiaochengxuma.48fd7a69.png";